export const required = (messageKey) => (value) => value ? undefined : messageKey;

export const email = (messageKey) => (value) => 
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? messageKey
    : undefined;

export const phoneNumber = value =>
  value && !/^\+?[\d] [-(]?\d{3}\)?-?\d{3}-?\d{2}-?\d{2}$/i.test(value)
    ? 'validatePhone'
    : undefined;


// WEBPACK FOOTER //
// ./src/utils/validate.js